export const DateReplacementKey = '{{Date}}';
export const PriceReplacementKey = '{{Price}}';
export const TotalReplacementKey = '{{Total}}';

export const NHSTrustSelectText = 'NHS Trust';
export const NHSFoundationTrustSelectText = 'NHS Foundation Trust';

export const HomeDataTypeName = 'home';
export const LandingDataTypeName = 'landing';
export const ArticleDataTypeName = 'article';
export const ProductDetailsDataTypeName = 'product';

export const DataTypeAttributeName = 'data-type';
export const DataColourAttributeName = 'data-color';

export const UserSessionTokenCookieName = 'UserSessionToken';

export const LeftToRightDirValue = 'ltr';
export const RightToLeftDirValue = 'rtl';

export const BaselineLanguage = 'en-gb';

export const BrandIconFileName = 'icon.svg';
export const FaviconFileName = 'favicon.ico';
export const AppleTouchIconFileName = 'apple-touch-icon.png';

/** Will match on a 2 part path (e.g. `en-gb` or `fr-fr`) but won't match on a single locale part */
export const LocalisationPatternMatcher = '(?:/[a-z]{2}-[a-z]{2})?';
